import { useEffect, useState } from "react";
import { useLocation } from "react-router";

/**
 * Mobile/off-canvas nav drawer state that auto-closes on navigation.
 *
 * Route change — not nav-item onClick — is the single source of truth for
 * "the user navigated". onClick={close} handlers miss programmatic navigate()
 * calls (e.g. GalaxySwitcher selecting a galaxy), which left the drawer open.
 * Keying the close on useLocation() catches every navigation, manual or not.
 */
export function useNavDrawer() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return { open, setOpen } as const;
}
